'use client';
import { createContext, useContext } from 'react';
const DataTableContext = createContext(null);
export const DataTableProvider = DataTableContext.Provider;
export function useDataTable() {
    const ctx = useContext(DataTableContext);
    if (!ctx) {
        throw new Error('DataTable compound members must be rendered inside <DataTable>.');
    }
    return ctx;
}
export function useTypedTable() {
    return useDataTable().table;
}
//# sourceMappingURL=context.js.map